declare var angular: ng.IAngularStatic;
export class orderService {
    constructor(private $http, private MyConstant, private localStorageService, private $resource, private $q) {
        "ngInject"

    }

    checkStatus(data) {
        return this.$http.post(`${this.MyConstant.ApiUrl}ECBSetOrder/GetCurrentSalableStatus`, data)
    }

    // checkOrderStatus(orderId, user) {
    //     this.$cart.getByOrderId(orderId, user)
    // }

    setOrder(order) {
        return this.$q((resolve, reject) => {
            this.$http.post(`${this.MyConstant.ApiUrl}ECBSetOrder/SetOrder`, [order]).then(
                response => {
                    this.localStorageService.set(`order${response.data[0].OrderID}`, response.data[0])
                    resolve(response.data)
                }
            )
        })
    }

    getOrder(orderId) {
        let order = this.localStorageService.get(`order${orderId}`) || {}
        return order
    }

    getUserOrders() {
        return this.$http.get(`${this.MyConstant.ApiUrl}ECBSetOrder/GetUserOrders`)
    }

    getUserOrder(orderId) {
        return this.$http.get(`${this.MyConstant.ApiUrl}UserOrders/GetUserOrderDetail?orderId=${orderId}`)
    }

    confirmOrder(orderId) {
        return this.$http.get(`${this.MyConstant.ApiUrl}ECBSetOrder/ConfirmOrder?orderId=${orderId}`)
    }

    paymentStatus(transactionID) {
        return this.$http.get(`${this.MyConstant.ApiUrl}ECBPayment/CheckPaymentStatus/?transactionID=${transactionID}`)
    }

    review(orderId) {
        return this.$http.get(`${this.MyConstant.ApiUrl}ECBSetOrder/ReviewOrder?orderId=${orderId}`)
    }

    $address() {
        return this.$resource('', {}, {
            query: {
                url: `${this.MyConstant.ApiUrl}ECBCartShipment/GetAddresses`,
                isArray: true
            },
            save: {
                method: 'POST',
                url: `${this.MyConstant.ApiUrl}ECBCartShipment/AddAddress`,
                transformResponse: function (data) {
                    return { id: data }

                }
            },
            remove: {
                method: 'POST',
                url: `${this.MyConstant.ApiUrl}ECBCartShipment/RemoveAddressById`
            }
        })
    }
    shippmentMethod(orderId) {
        return this.$http.get(`${this.MyConstant.ApiUrl}ECBCartShipment/GetShipmentInfo?orderId=${orderId}`)
    }

    paymentMethod(orderId) {
        let order = this.getOrder(orderId)
        let vendorId = order.VendorID;
        return this.$http.get(`${this.MyConstant.ApiUrl}ECBCartShipment/GetVendorPaymentMethodsByVendorID/?VendorID=${vendorId}`)
    }
}


// WEBPACK FOOTER //
// ./src/services/order/order.ts